import React, { useState } from 'react';
import {
	Grid,
	TextField,
	Box,
	makeStyles,
	FormControlLabel,
	Checkbox,
	Radio,
	RadioGroup,
	FormControl,
} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import busIcon from '../assets/images/busIcon.jpg';
import { useDispatch, useSelector } from 'react-redux';
import DateRange from '../components/reusableComponents/DateRange';
import DateRangeNew from '../components/reusableComponents/DateRangeNew';
import BodyText from '../components/reusableComponents/BodyText';
import TitleText from '../components/reusableComponents/TitleText';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import {
	SearchReturnFormDispatch,
	SearchFormDispatch,
} from '../reducers/HomeReducer';
import Typed from 'typed.js';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import DesktopDate from '../components/reusableComponents/DesktopDate';
import DesktopDateNew from '../components/reusableComponents/DesktopDateNew';
import { fetchBusSearchDispatch } from '../reducers/BusReducer';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiFormControl-root': {
			'& div': {
				'& div': {
					display: 'none',
				},
			},
		},
		'& .MuiInput-underline:before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},
		'& input': {
			fontSize: 22,
		},
	},
	radio: {
		'& .MuiRadio-root': {
			color: 'white',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'white',
			fontSize: 14,
		},
	},
}));
const BusServiceForm = () => {
	const [result, setResult] = useState([]);
	const [result2, setResult2] = useState([]);
	const classes = useStyles();
	const { city } = useSelector((state) => state.home);
	const { buscity } = useSelector((state) => state.bus);
	const handleRadio = (event) => {
		setValue(event.target.value);
	};
	const history = useHistory();
	const dispatch = useDispatch();
	const [data, setData] = useState(true);

	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const [value, setValue] = useState('Economy');
	const [leaving, setLeaving] = useState('DEL');
	const [trip, setTrip] = useState('oneway');
	const [going, setGoing] = useState('CCU');
	const { origin, depart } = useSelector((state) => state.ui);
	const el = React.useRef(null);
	// Create reference to store the Typed instance itself
	const typed = React.useRef(null);
	React.useEffect(() => {
		const options = {
			strings: [
				' Book Bus And Explore The World With Us',
				// ' Welcome to <strong>MusafirBazar</strong>',
				// 'HTML characters &times; &copy;',
			],
			typeSpeed: 50,
			backSpeed: 50,
			// loop: true,
		};

		// elRef refers to the <span> rendered below
		typed.current = new Typed(el.current, options);

		// return () => {
		// 	// Make sure to destroy Typed instance during cleanup
		// 	// to prevent memory leaks
		// 	typed.current.destroy();
		// };
	}, []);
	let cityOptions = [];
	let demo = [];
	buscity &&
		buscity.result &&
		buscity.result.cities &&
		buscity.result.cities.length > 0 &&
		buscity.result.cities.forEach((invoice, index) => {
			cityOptions.push({
				id: invoice.id,
				name: invoice.name,
				state: invoice.state,
			});
			if (index < 10) {
				demo.push({
					id: invoice.id,
					name: invoice.name,
					state: invoice.state,
				});
			}
		});
	const handleSubmit = (data) => {
		// console.log(data);
		let formData = {
			arrival_city: data.arrival_city,
			departure_city: data.departure_city,
			destinationid: data.destinationid,
			sourceid: data.sourceid,
			dateofjourney: '2022-03-18',
		};
		console.log(formData);
		dispatch(fetchBusSearchDispatch(formData));
		// let formData = {
		// 	JourneyType: 1,
		// 	Origin: data.Origin,
		// 	Destination: data.Destination,
		// 	AdultCount: adult,
		// 	ChildCount: child,
		// 	InfantCount: infant,
		// 	PreferredDepartureTime: origin,
		// };
		// let formData2 = {
		// 	JourneyType: 2,
		// 	Origin: data.Origin,
		// 	Destination: data.Destination,
		// 	AdultCount: adult,
		// 	ChildCount: child,
		// 	InfantCount: infant,
		// 	PreferredDepartureTime: origin,
		// 	ReturnPreferredDepartureTime: depart,
		// };
		// // dispatch(SearchReturnFormDispatch(formData2, history));
		// if (trip === 'oneway') {
		// 	dispatch(SearchFormDispatch(formData, history));
		// } else {
		// 	dispatch(SearchReturnFormDispatch(formData2, history));
		// }
	};
	console.log(cityOptions);
	const handleSearch = (event) => {
		let value = event.target.value.toLowerCase();
		console.log(value);
		if (value.length >= 2) {
			let results =
				cityOptions &&
				cityOptions.filter((data) => {
					return Object.values(data).join('').toLowerCase().includes(value);
				});
			setResult(results);
		} else {
			setResult([]);
		}
	};
	const handleSearch2 = (event) => {
		let value = event.target.value.toLowerCase();
		let results = [];
		console.log(value);
		if (value.length >= 2) {
			results =
				cityOptions &&
				cityOptions.filter((data) => {
					return Object.values(data).join('').toLowerCase().includes(value);
				});
			setResult2(results);
		} else {
			setResult2([]);
		}
	};
	console.log(leaving);
	console.log(going);
	const handleChange2 = (e) => {
		console.log(e.target.value);
		dispatch(setTrip(e.target.value));
	};
	return (
		<>
			<Formik
				initialValues={{
					arrival_city: 'Durgapur',
					departure_city: '',
					sourceid: '',
					destinationid: '',
				}}
				validate={(values) => {
					const errors = {};
				}}
				onSubmit={handleSubmit}>
				{({ submitForm, isSubmitting, setFieldValue, values }) => (
					<>
						<Form style={{ marginTop: 180 }}>
							<p style={{ color: 'white', fontSize: 36 }} ref={el}></p>
							{/* <Box className={classes.radio}>
								<FormControl onChange={handleChange2}>
									<RadioGroup
										row
										aria-labelledby='demo-row-radio-buttons-group-label'
										name='row-radio-buttons-group'>
										<FormControlLabel
											value='oneway'
											control={
												<Radio checked={trip == 'oneway' ? true : false} />
											}
											label='ONE WAY'
										/>
										<FormControlLabel
											value='roundtrip'
											control={
												<Radio checked={trip == 'roundtrip' ? true : false} />
											}
											label='ROUND TRIP'
										/>
									</RadioGroup>
								</FormControl>
							</Box> */}
							<Grid
								container
								spacing={2}
								alignItems='center'
								style={{ marginTop: 10 }}>
								<Grid item xs={12} md={12} lg={6}>
									<Grid container alignItems='center' spacing={2}>
										<Grid
											item
											xs={6}
											style={{ display: 'flex', alignItems: 'center' }}>
											<div className={classes.root} style={{ width: '100%' }}>
												<span style={{ color: 'white' }}>From</span>
												<Autocomplete
													id='country-select-demo'
													sx={{
														background: '#eee',
														borderRadius: 2,
														padding: '10px',
													}}
													options={
														result && result.length > 0
															? result
															: demo && demo.length > 0
															? demo
															: []
													}
													autoHighlight
													getOptionLabel={(option) => option.name}
													renderOption={(props, option) => (
														<Box
															mr={'5px'}
															component='li'
															sx={{ '& > img': { mr: 2 } }}
															{...props}>
															<img
																loading='lazy'
																width='20'
																src={busIcon}
																alt=''
															/>
															{/* <i class='fas fa-bus'></i> */}
															<p style={{ fontSize: 13 }}>{option.name}</p>
														</Box>
													)}
													onChange={(event, value) => {
														setFieldValue('arrival_city', value.name);
														setFieldValue('sourceid', value.id);
														console.log(value.code);
														// setLeaving(value.code);
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															onChange={handleSearch}
															name='origin'
														/>
													)}
												/>
											</div>
											{/* <SwapHorizontalCircleIcon
												onClick={() => {
													setLeaving(going);
													setGoing(leaving);
													// setData(false);

													// console.log('first');
												}}
												style={{
													color: 'white',
													width: '4em',
													height: '3em',
													marginTop: 20,
													cursor: 'pointer',
												}}
											/> */}
										</Grid>
										{/* <Grid item xs={2} style={{ marginTop: 17 }}>
											
										</Grid> */}
										<Grid item xs={6}>
											<div className={classes.root}>
												<span style={{ color: 'white' }}>To</span>
												<Autocomplete
													id='country-select-demo'
													sx={{
														background: '#eee',
														borderRadius: 2,
														padding: '10px',
													}}
													options={
														result2 && result2.length > 0
															? result2
															: demo && demo.length > 0
															? demo
															: []
													}
													autoHighlight
													getOptionLabel={(option) => option.name}
													renderOption={(props, option) => (
														<Box
															component='li'
															sx={{ '& > i': { mr: 2, flexShrink: 0 } }}
															{...props}>
															<img loading='lazy' width='20' src={busIcon} />{' '}
															{option.name}
														</Box>
													)}
													onChange={(event, value) => {
														setFieldValue('departure_city', value.name);
														setFieldValue('destinationid', value.id);
														// setGoing(value.code);
													}}
													renderInput={(params) => (
														<TextField {...params} onChange={handleSearch2} />
													)}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								{/* <Grid item xs={12} md={6} lg={2}>
									<div className={classes.root}>
										<span style={{ color: 'white' }}>Going To</span>
										<Autocomplete
											id='country-select-demo'
											sx={{
												background: '#eee',
												borderRadius: 2,
												padding: '10px',
											}}
											options={result2 && result2.length > 0 ? result2 : []}
											autoHighlight
											getOptionLabel={(option) => option.code}
											renderOption={(props, option) => (
												<Box
													component='li'
													sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
													{...props}>
													<img loading='lazy' width='20' src={flt} />
													{option.city} ({option.code}) {option.country}
												</Box>
											)}
											onChange={(event, value) =>
												setFieldValue('Destination', value.code)
											}
											renderInput={(params) => (
												<TextField {...params} onChange={handleSearch2} />
											)}
										/>
									</div>
								</Grid> */}
								<Grid
									item
									xs={12}
									md={12}
									lg={trip == 'oneway' ? 3 : trip == 'roundtrip' ? 3 : 3}>
									{/* <div className={classes.root}> */}
									<Box display='flex' justifyContent='space-between'>
										<span style={{ color: 'white' }}>Depart Date</span>
										{trip == 'oneway' ? (
											''
										) : trip == 'roundtrip' ? (
											<span style={{ color: 'white' }}>Return Date</span>
										) : (
											''
										)}
										{/* <span style={{ color: 'white' }}>Return Date</span> */}
									</Box>
									{trip == 'oneway' ? (
										<DesktopDateNew />
									) : trip == 'roundtrip' ? (
										<DateRangeNew />
									) : (
										<DesktopDateNew />
									)}
									{/* <DateRangeNew /> */}
									{/* <DesktopDateNew /> */}
									{/* </div> */}
								</Grid>

								<Grid item xs={12} md={6} lg={3} style={{ marginTop: 12 }}>
									<input
										type='submit'
										value='book now'
										className='btn'
										style={{ width: '100%', fontSize: 30, borderRadius: 5 }}
									/>
								</Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default BusServiceForm;
